import moment from "moment";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Dropdown } from "react-bootstrap";

const AddEditReportTimeModal = ({
  show = false,
  onHide = () => {},
  editingIndex = null,
  initialData = null,
  onSave = () => {},
}) => {
  const [showError, setShowError] = useState("");
  const [modalTimes, setModalTimes] = useState([
    {
      time: "",
      hour: "00",
      minute: "00",
      recur: {
        freq: "",
        interval: 1,
        byDay: [],
        byMonthDay: [],
      },
      isActive: true,
    },
  ]);

  const [activeTab, setActiveTab] = useState(0);

  const daysOfWeek = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 0 },
  ];

  function getOrdinalSuffix(num) {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
  }

  const ANOTHERDATE = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  // Initialize modal data
  useEffect(() => {
    if (show) {
      if (editingIndex !== null && initialData) {
        const timeData = Array.isArray(initialData)
          ? initialData
          : [initialData];
        setModalTimes(
          timeData.map((item) => ({
            ...item,
            time: `${item.hour || "00"}:${item.minute || "00"}`,
            hour: item.hour || "00",
            minute: item.minute || "00",
            recur: {
              freq: item.recur?.freq || "",
              interval: item.recur?.interval || 1,
              byDay: item.recur?.byDay || [],
              byMonthDay: item.recur?.byMonthDay || [],
              anchorDate: moment().format("YYYY-MM-DD"),
            },
            isActive: item.isActive !== undefined ? item.isActive : true,
          })),
        );
      } else {
        setModalTimes([
          {
            time: "",
            hour: "00",
            minute: "00",
            recur: {
              freq: "",
              interval: 1,
              byDay: [],
              byMonthDay: [],
            },
            isActive: true,
          },
        ]);
      }
      setActiveTab(0);
    }
  }, [show, editingIndex, initialData]);

  const handleClose = () => {
    setModalTimes([
      {
        time: "",
        hour: "00",
        minute: "00",
        recur: {
          freq: "",
          interval: 1,
          byDay: [],
          byMonthDay: [],
        },
        isActive: true,
      },
    ]);
    setActiveTab(0);
    onHide();
    setShowError("");
  };

  const handleSaveTimes = () => {
    const isValid = modalTimes.every((timeObj) => {
      return (
        timeObj.time &&
        timeObj.recur.freq &&
        (timeObj.recur.freq === "DAILY" ||
          timeObj.recur.freq === "MONTHLY" ||
          timeObj.recur.freq === "QUARTERLY" ||
          (timeObj.recur.byDay && timeObj.recur.byDay.length > 0))
      );
    });

    if (!isValid) {
      setShowError("Please fill in all required fields for each time slot.");
      return;
    }

    const formattedTimes = modalTimes.map((timeObj) => ({
      ...timeObj,
      hour: timeObj.hour,
      minute: timeObj.minute,
      recur: {
        freq:
          timeObj.recur.freq === "QUARTERLY" ? "MONTHLY" : timeObj.recur.freq,
        interval:
          timeObj.recur.freq === "BIWEEKLY"
            ? 2
            : timeObj.recur.freq === "QUARTERLY"
              ? 3
              : 1,
        byDay:
          timeObj.recur.freq === "DAILY" || timeObj.recur.freq === "MONTHLY"
            ? []
            : timeObj.recur.byDay,
        byMonthDay:
          timeObj.recur.freq === "MONTHLY" || timeObj.recur.freq === "QUARTERLY"
            ? timeObj.recur.byMonthDay
            : [],
        anchorDate: moment().format("YYYY-MM-DD"),
      },
      isActive: timeObj.isActive !== undefined ? timeObj.isActive : true,
    }));

    onSave(formattedTimes, editingIndex);
    handleClose();
  };

  const toggleModalWeekDay = (index, value) => {
    setModalTimes((prevTimes) => {
      const newTimes = [...prevTimes];
      const current = newTimes[index].recur.byDay || [];

      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];

      newTimes[index] = {
        ...newTimes[index],
        recur: {
          ...newTimes[index].recur,
          byDay: updated,
        },
      };

      return newTimes;
    });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            {editingIndex !== null ? "Edit Report Time" : "Add Report Time"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalTimes.map((timeObj, index) => (
            <Form
              key={index}
              style={{ padding: "0px 20px", boxShadow: "none", border: "none" }}
            >
              <Row className="mb-2">
                {/* Time Field */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Time <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="time"
                      value={
                        timeObj.time ||
                        `${timeObj.hour || "00"}:${timeObj.minute || "00"}`
                      }
                      onChange={(e) =>
                        setModalTimes((prevTimes) => {
                          const newTimes = [...prevTimes];
                          const val = e.target.value || "00:00";
                          const [h = "00", m = "00"] = val.split(":");
                          newTimes[index] = {
                            ...newTimes[index],
                            time: val,
                            hour: h,
                            minute: m,
                          };
                          return newTimes;
                        })
                      }
                      style={{ height: "40px" }}
                      required
                    />
                  </Form.Group>
                </Col>

                {/* Frequency Field */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Frequency <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={
                        timeObj.recur?.freq === "MONTHLY" &&
                        timeObj.recur?.interval === 3
                          ? "QUARTERLY"
                          : timeObj.recur?.freq || ""
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        setModalTimes((prevTimes) => {
                          const newTimes = [...prevTimes];
                          newTimes[index] = {
                            ...newTimes[index],
                            recur: {
                              ...newTimes[index].recur,
                              freq: value,
                              interval:
                                value === "BIWEEKLY"
                                  ? 2
                                  : value === "QUARTERLY"
                                    ? 3
                                    : 1,
                              byDay:
                                value === "DAILY" ||
                                value === "MONTHLY" ||
                                value === "QUARTERLY"
                                  ? []
                                  : newTimes[index].recur.byDay,
                              byMonthDay:
                                value === "MONTHLY" || value === "QUARTERLY"
                                  ? newTimes[index].recur.byMonthDay
                                  : [],
                            },
                          };
                          return newTimes;
                        });
                      }}
                      required
                    >
                      <option value="">Select Frequency</option>
                      <option value="DAILY">Daily</option>
                      <option value="WEEKLY">Weekly</option>
                      {/* <option value="BIWEEKLY">Biweekly</option> */}
                      <option value="MONTHLY">Monthly</option>
                      <option value="QUARTERLY">Quarterly</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* ✅ Week Days Dropdown (with checkboxes) */}
                <Col md={6} className="mb-3">
                  <Form.Group>
                    <Form.Label>
                      Week Days
                      {(timeObj.recur?.freq === "WEEKLY" ||
                        timeObj.recur?.freq === "BIWEEKLY") && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>

                    <Dropdown className="w-100 border rounded">
                      <Dropdown.Toggle
                        variant="light"
                        className={`w-100 text-start ${
                          timeObj.recur?.freq === "DAILY" ||
                          timeObj.recur?.freq === "MONTHLY" ||
                          timeObj.recur?.freq === "QUARTERLY"
                            ? "custom-disabled-dropdown"
                            : ""
                        }`}
                        disabled={
                          timeObj.recur?.freq === "DAILY" ||
                          timeObj.recur?.freq === "MONTHLY" ||
                          timeObj.recur?.freq === "QUARTERLY"
                        }
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "block",
                        }}
                      >
                        {timeObj.recur?.byDay?.length > 0
                          ? daysOfWeek
                              .filter((d) =>
                                timeObj.recur.byDay.includes(d.value),
                              )
                              .map((d) => d.label)
                              .join(", ")
                          : "Select Week Days"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        className="w-100"
                        style={{
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        {daysOfWeek.map((day) => (
                          <Dropdown.Item
                            as="div"
                            key={day.value}
                            className="d-flex align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation(); // keep dropdown open
                              toggleModalWeekDay(index, day.value); // ✅ label / row click
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              label={day.label}
                              checked={timeObj.recur?.byDay?.includes(
                                day.value,
                              )}
                              onChange={() => {}} // controlled by parent
                              onClick={(e) => e.stopPropagation()} // prevent double toggle
                            />
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Form.Group>
                </Col>

                {/* Month Days */}
                <Col md={6} className="mb-3">
                  <Form.Group>
                    <Form.Label>
                      Month Days
                      {timeObj.recur?.freq === "MONTHLY" && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>
                    <Form.Select
                      name="byMonthDay"
                      value={
                        timeObj.recur?.freq === "DAILY"
                          ? ""
                          : timeObj.recur?.byMonthDay?.[0] || ""
                      }
                      disabled={
                        timeObj.recur?.freq !== "MONTHLY" &&
                        timeObj.recur?.freq !== "QUARTERLY"
                      }
                      onChange={(e) =>
                        setModalTimes((prevTimes) => {
                          const newTimes = [...prevTimes];
                          newTimes[index] = {
                            ...newTimes[index],
                            recur: {
                              ...newTimes[index].recur,
                              byMonthDay: e.target.value
                                ? [Number(e.target.value)]
                                : [],
                            },
                          };
                          return newTimes;
                        })
                      }
                    >
                      <option value="">Select Day of Month</option>
                      {ANOTHERDATE.map((day) => (
                        <option key={day.value} value={day.value}>
                          {day.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {modalTimes.length > 1 && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() =>
                    setModalTimes((prev) => prev.filter((_, i) => i !== index))
                  }
                >
                  Remove This Time
                </Button>
              )}
            </Form>
          ))}
          {showError && <p className="text-danger text-center">{showError}</p>}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="success" onClick={handleSaveTimes}>
            Save Timings
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddEditReportTimeModal;
